import {
  Drawer,
  DrawerHeader,
  DrawerBody,
  drawerProps
} from 'components/pcc-components';
import { useTranslations } from 'next-intl';
import styles from './fitment-mobile-drawer.module.scss';
import cx from 'classnames';

export type FitmentMobileDrawerProps = {
  subtitle: string;
  content: string;
  drawerProps: drawerProps;
};

const FitmentMobileDrawer = ({
  subtitle,
  content,
  drawerProps
}: FitmentMobileDrawerProps) => {
  const t = useTranslations();

  return (
    <Drawer
      {...drawerProps}
      orientation="bottom"
      verticalMaxHeight="large"
      className={styles['fitment-mobile-drawer']}
    >
      <DrawerHeader>
        <h4 className={'cat-u-theme-typography-title-sm m-0 u-color--Black '}>
          {t('PART_FACTORY_FIT')}
        </h4>
      </DrawerHeader>
      <DrawerBody
        className={cx(
          'cat-u-theme-typography-body',
          styles['fitment-mobile-drawer__body']
        )}
      >
        <p className={styles['fitment-mobile-drawer__subtitle']}>{subtitle}</p>
        <p>{content}</p>
      </DrawerBody>
    </Drawer>
  );
};

export default FitmentMobileDrawer;
